import React, { useState } from 'react';

const tabs = [
    'Total Sales',
    'SLAI Closing Rate',
    'Human Closing Rate',
    'Calls Made',
    'Follow-Up Success Rate',
    'Calls Connected'
];

const FiltersTabs = () => {
    const [activeTab, setActiveTab] = useState(tabs[0]);

    return (
        <div className="filters-container">
            <button className="btn customize-btn">Customize Tables</button>
            <select className="date-select">
                <option>Today</option>
                <option>Yesterday</option>
                <option>Last 7 Days</option>
                <option>Last 30 Days</option>
            </select>
            <div className="tabs">
                {tabs.map((tab) => (
                    <div
                        key={tab}
                        className={`tab ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FiltersTabs;
